import React from 'react';

interface ITollRouteIconProps {
	className?: string;
	size?: string;
	iconAsBadge?: boolean;
}

export const TollRoute = ({ className, iconAsBadge = false, size = '72' }: ITollRouteIconProps) => {
	return iconAsBadge ? (
		<svg width="28" height="28" viewBox="0 0 28 28" className={className} fill="none">
			<path d="M5 14.0001L14 10.1001L23 14.0001V15.9501L14 12.0501L5 15.9501V14.0001Z" fill="#008035" />
			<path d="M5 17.2501L14 13.3501L23 17.2501V22.4501L14 18.5501L5 22.4501V17.2501Z" fill="#008035" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2 6C2 3.79086 3.79086 2 6 2H22C24.2091 2 26 3.79086 26 6V22C26 24.2091 24.2091 26 22 26H6C3.79086 26 2 24.2091 2 22V6ZM6 4H22C23.1046 4 24 4.89543 24 6V22C24 23.1046 23.1046 24 22 24H6C4.89543 24 4 23.1046 4 22V6C4 4.89543 4.89543 4 6 4Z"
				fill="#008035"
			/>
		</svg>
	) : (
		<svg width={size} height={size} className={className} viewBox="0 0 72 72" fill="none">
			<rect width="72" height="72" fill="#F4F4F2" />
			<rect
				x="11.25"
				y="11.25"
				width="49.5"
				height="49.5"
				rx="7.25"
				fill="white"
				stroke="#707070"
				strokeWidth="1.5"
			/>
			<rect x="14.25" y="14.25" width="43.5" height="43.5" rx="3" fill="#F4F4F4" />
			<path d="M25.6013 39.75L36 35.25L46.3986 39.75V45.75L36 41.25L25.6013 45.75V39.75Z" fill="#008035" />
			<path d="M25.6013 36L36 31.5L46.3986 36V38.25L36 33.75L25.6013 38.25V36Z" fill="#008035" />
			<rect x="23.25" y="22.5" width="25.5" height="27" rx="2.5" stroke="#008035" strokeWidth="3" />
			<path d="M3 60.75H64.5" stroke="#707070" strokeWidth="1.5" />
			<path d="M66.75 60.75L69 60.75" stroke="#707070" strokeWidth="1.5" />
		</svg>
	);
};
